import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { toggleFormat } from '@wordpress/rich-text';
import { RichTextToolbarButton } from '@wordpress/block-editor';
import { formatStrikethrough } from '@wordpress/icons';
const name = 'core/strikethrough';

const title = __('Strikethrough');

export const strikethrough = {
  name,
  title,
  tagName: 's',
  className: null,

  edit(_ref) {
    let {
      isActive,
      value,
      onChange,
      onFocus
    } = _ref;

    function onClick() {
      onChange(toggleFormat(value, {
        type: name,
        title
      }));
      onFocus();
    }

    return createElement(RichTextToolbarButton, {
      icon: formatStrikethrough,
      title: title,
      onClick: onClick,
      isActive: isActive,
      role: "menuitemcheckbox"
    });
  }

};
//# sourceMappingURL=index.js.map